import styled from 'styled-components';

import colors from '../../../styles/colors';

export const LegendList = styled.ul`
  padding: 0;
  margin: 0;
  text-align: right;

  li {
    display: inline-block;
    margin-right: 10;
  }
`;

export const ContainerLegendType = styled.div`
  float: left;

  .anticon {
    color: ${colors.$brandcolor_primary_dark_green_5};
    font-size: 22px;
  }
`;

export const LabelLegend = styled.span`
  margin: 0 5px;
  font-weight: 500;
`;
